var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-4",
          attrs: {
            "color": _vm.color,
            "type": "submit",
            "disabled": _vm.disabled
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(_vm._s(_vm.icon))])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }